import { render, staticRenderFns } from "./GroupOfAccreditationItem.vue?vue&type=template&id=e280f430"
import script from "./GroupOfAccreditationItem.vue?vue&type=script&lang=js"
export * from "./GroupOfAccreditationItem.vue?vue&type=script&lang=js"
import style0 from "./GroupOfAccreditationItem.vue?vue&type=style&index=0&id=e280f430&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports